import React, {
    useCallback, useEffect, useContext, useState
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './WhatPage.metadata.json5';
import styles from './WhatPage.module.scss';
import {messages} from '../../FNOLBOP.messages';

function FNOLBOWhatPage(props) {
    const translator = useContext(TranslatorContext);
    const {
        wizardData: claimVM,
        updateWizardData,
        history: { location: { state = {} } }
    } = props;
    const {
        onValidate, isComponentValid, initialValidation, registerInitialComponentValidation
    } = useValidation('FNOLBOWhatPage');

    const [liabilityAndPRTypeCodes, updateLiabilityAndPRTypeCodes] = useState([]);
    const [glTypeCodes, updateGLTypeCodes] = useState([]);
    const [prTypeCodes, updatePRTypeCodes] = useState([]);
    //const [isLoading, setIsLoading] = useState(false);

    const { claimStatus } = state;

    const validateClaimStatus = useCallback(() => {
        return !_.isEmpty(claimStatus) && claimStatus === translator({ id: 'typekey.ClaimState.draft', defaultMessage: 'Draft' });
    }, [claimStatus, translator]);

    useEffect(() => {
        registerInitialComponentValidation(validateClaimStatus);
    }, [validateClaimStatus, registerInitialComponentValidation]);

    useEffect(() => {
        const detailsGLAndPRClaimTypeCodes = _.filter(
            claimVM.lossType.aspects.availableValues,
            (typeCode) => {
                const excludeClaimTypeCodesList = [
                    'AUTO',
                    'TRAV',
                    'WC'
                ];
                return excludeClaimTypeCodesList.indexOf(typeCode.code) === -1;
            }
        ).map((claimTypeObj) => {
            return {
                code: claimTypeObj.code,
                name: translator({
                    id: claimTypeObj.name,
                    defaultMessage: claimTypeObj.name
                })
            };
        });

        const detailsGLFarmLoss = claimVM.glfarmLossCause.aspects.availableValues.map((typeObj) => {
            return {
                code: typeObj.code,
                name: translator({
                    id: typeObj.name,
                    defaultMessage: typeObj.name
                })
            };
        });

        const detailsPRFarmLoss = claimVM.prfarmLossCause.aspects.availableValues.map((typeObj) => {
            return {
                code: typeObj.code,
                name: translator({
                    id: typeObj.name,
                    defaultMessage: typeObj.name
                })
            };
        });
        updateLiabilityAndPRTypeCodes(detailsGLAndPRClaimTypeCodes);
        updateGLTypeCodes(detailsGLFarmLoss);
        updatePRTypeCodes(detailsPRFarmLoss);
        // It should call once when page is rendered
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onHandleClaimTypeChange = (value, path) => {
        _.set(claimVM, path, value);
        updateWizardData(claimVM);
    };

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        /*whatPageLoader: {
            loaded: !isLoading,
            loadingMessage: translator(messages.bopCreateDraftClaim)
        },*/
        typeOfClaimDropDown: {
            availableValues: liabilityAndPRTypeCodes
        },
        glbopLossCategory: {
            visible: _.get(claimVM, 'lossType.value.code') === 'GL',
            availableValues: glTypeCodes
        },
        prbopLossCategory: {
            visible: _.get(claimVM, 'lossType.value.code') === 'PR',
            availableValues: prTypeCodes
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onHandleClaimTypeChange: onHandleClaimTypeChange
        }
    };

    return (
        <WizardPage
            disableNext={!isComponentValid}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

FNOLBOWhatPage.propTypes = wizardProps;
export default withRouter(FNOLBOWhatPage);

